import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { Paging } from 'core-components/library/list'
import { ColumnsFilter } from 'core-components/library/list/table/ColumnsFilter'
import { Export } from 'core-components/library/list/table/paging/Export'
import { IColumn, ITableProps } from 'core-components/library/list/types'
import { BaseCrud } from 'core-components/types'

import styles from './Footer.module.scss'

interface IFooter<P = IForm, R = string | number> {
  pagination?: ITableProps['pagination']
  pageSize?: ITableProps['pageSize']
  rowsPerPageOptions?: ITableProps['rowsPerPageOptions']
  titleRender?: ITableProps['titleRender']
  hasExport?: ITableProps['hasExport']
  exportTooltip?: ITableProps['exportTooltip']
  exportColumns?: ITableProps['exportColumns']
  onExportClick?: ITableProps['onExportClick']
  hasRefresh?: ITableProps['hasRefresh']
  exportFileName?: ITableProps['exportFileName']
  hasColumnsVisibilityOptions?: ITableProps['hasColumnsVisibilityOptions']
  columnsFilterKey?: ITableProps['columnsFilterKey']
  total: number
  wip: boolean
  columns: IColumn[]
  source: BaseCrud<P, R>
  updateColumns: (newColumns: IColumn[]) => void
}

export const Footer = <P = IForm, R = string | number>({
  total,
  wip,
  columns,
  source,
  updateColumns,
  hasColumnsVisibilityOptions = true,
  ...props
}: IFooter<P, R>) => {
  return (
    <div className={styles.footer}>
      {props.pagination && (
        <Paging
          source={source}
          pageSize={props.pageSize}
          total={total}
          rowsPerPageOptions={props.rowsPerPageOptions}
          wip={wip}
          titleRender={props.titleRender}
        />
      )}
      <div className={styles.footer__actions}>
        {props.hasExport && (
          <Export<P, R>
            source={source}
            isDataLoading={wip}
            tooltip={props.exportTooltip}
            columns={columns}
            exportColumns={props.exportColumns}
            onExportClick={props.onExportClick}
            exportFileName={props.exportFileName}
          />
        )}
        {props.hasRefresh && (
          <Button
            title="Refresh Data"
            iconButton={'kbase kbase-reload'}
            variant={'text'}
            onClick={() => {
              source.removeQueries(true)
              const { pageSize: currentPageSize, startPage: currentStartPage } = source.getPaging()

              source.setPaging({
                pageSize: props.pageSize || currentPageSize,
                page: currentStartPage || 0,
                startPage: currentStartPage ?? undefined,
              })
            }}
          />
        )}
        {hasColumnsVisibilityOptions ? (
          <ColumnsFilter
            titleRender={props.titleRender}
            columns={columns}
            columnsFilterKey={props.columnsFilterKey}
            setColumns={updateColumns}
          />
        ) : null}
      </div>
    </div>
  )
}
